import { Button, Col, Row } from "antd";
import CodeSyntaxHighlighter from "../../../../component/syntax-highlighter";

export default function Introduce() {
  const npmInstallScript = "npm install @waxio/widget-marketplace";
  return (
    <Row className="introduce" align={"middle"} justify="space-between">
      <Col xs={24} lg={10}>
        <video
          muted
          loop
          autoPlay
          className="image"
          poster="/image/home/introduction.png"
          src="/image/home/introduction.webm"
        />
      </Col>
      <Col xs={24} lg={12}>
        <Row>
          <Col xs={24}>
            <Row gutter={[24, 24]}>
              <Col xs={24}>
                <h1 className="center-when-mobile">
                  Start your own{" "}
                  <span
                    style={{ display: "block" }}
                    className="color-primary typewriter"
                  >
                    NFT Marketplace
                  </span>
                </h1>
              </Col>
              <Col xs={24}>
                <p
                  style={{ color: "#777E90", marginBottom: 24 }}
                  className="w-font-md fw-600 center-when-mobile"
                >
                  Empower your digital assets with our fast and simple
                  community-driven tools to create your own NFT Marketplace.
                  Launch your embedded NFT Market into your game, project, or
                  site today and unleash the full potential of your digital
                  assets!
                </p>
              </Col>
            </Row>
          </Col>
          <Col className="box" xs={24}>
            <Row justify={"center"} gutter={[0, 16]}>
              <Col>
                <h4 className="w-font-lg fw-600">
                  This is the command line for you
                </h4>
              </Col>
              <Col xs={24}>
                <Row justify={"center"} gutter={[0, 32]}>
                  <CodeSyntaxHighlighter code={npmInstallScript} />
                  <Col>
                    <Row justify={"center"} gutter={[8, 16]}>
                      <Col xs={24} style={{ textAlign: "center" }}>
                        <a href="/guideline">
                          <Button
                            style={{ width: "100%" }}
                            type="primary"
                            size="large"
                          >
                            SETUP YOUR MARKET
                          </Button>
                        </a>
                      </Col>
                      <Col
                        xs={24}
                        style={{
                          textAlign: "center",
                        }}
                      >
                        OR
                      </Col>
                      <Col xs={24}>
                        <Row gutter={8}>
                          <Col
                            style={{
                              textAlign: "center",
                              width: "calc(100% - 128px - 16px)",
                            }}
                          >
                            <a
                              rel="noreferrer"
                              target="_blank"
                              href="https://www.npmjs.com/package/@waxio/widget-marketplace"
                            >
                              <Button
                                style={{ width: "100%" }}
                                type="default"
                                size="large"
                              >
                                View NPM Library
                              </Button>
                            </a>
                          </Col>
                          <Col>
                            <a
                              target={"_blank"}
                              className="social-icon"
                              rel="noreferrer"
                              href="http://go.wax.io/Discord"
                            >
                              <img src="icon/community.svg" alt="" />
                            </a>
                          </Col>
                          <Col>
                            <a
                              rel="noreferrer"
                              target={"_blank"}
                              className="social-icon"
                              href="https://github.com/worldwide-asset-exchange/wax-marketplace-widget"
                            >
                              <img src="icon/github.svg" alt="" />
                            </a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <p
            style={{
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "18px",
              color: "#777E90",
              textAlign: "center",
              width: "100%",
              marginTop: 12,
            }}
          >
            Powered by vIRL Market
          </p>
        </Row>
      </Col>
    </Row>
  );
}
